<ng-container *ngIf="!userSessionService.isIntegration">
  <p *ngIf="userSessionService.authMessage">{{userSessionService.authMessage}}</p>
</ng-container>
<section class="text-center mt-4" *ngIf="errorMessage">
  <mat-error>{{errorMessage}}</mat-error>
</section>